/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.ComponentKeywords";
        // Framework for keyword component types
        class ComponentKeywordsBase extends Widgets.ComponentBaseClass {
            //TODO: change the config type - can we share one type with all components?
            constructor(core, container, parent) {
                super(core, container, parent);
                // Form/interface handling
                this._formId = null;
                this._form = null;
                this._listRoot = null;
                this._editPanel = null;
                this._editPanelAcceptButton = null;
                this._editPanelCancelButton = null;
                // Readiness handling
                this._componentReady = false;
                this._cacheReady = false;
                this._requestPending = null;
                this._requestActive = null;
                // Actual data containers
                this._groupMap = {};
                // User limits/functionality support
                this._userCanAccessRestrictedKeys = false;
                // External interaction
                this.DataChangedCallback = null;
                this.NoKeysToDisplayCallback = null;
                this._storeHtml = (htmlData) => {
                    ComponentKeywordsBase.Html = htmlData;
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._cacheUpdated = () => {
                    this._cacheReady = true;
                    if (this._componentReady && this._requestPending)
                        this._servicePendingRequest();
                };
                this._sanityCheckRequest = (request) => {
                    return true;
                };
                this.makeRequest = (request) => {
                    // Sanity check input
                    if (!this._sanityCheckRequest(request)) {
                        console.error('KeywordsComponent received misconfigured request.');
                        /*if(this._log.isTraceEnabled()) {
                            let requestLog: string = '{';
                            for(let key in request) {requestLog += ` ${key}: "${request[key].toString()}"` }
                            requestLog += ' }'
                            this._log.trace(requestLog);
                        }*/
                        return false;
                    }
                    // Set some basics to ensure good behaviour
                    if (!request.hasOwnProperty('SimpleEditors') || (request.SimpleEditors == null))
                        request.SimpleEditors = false;
                    if (!request.hasOwnProperty('IncludeGroups') || (request.IncludeGroups == null))
                        request.IncludeGroups = [];
                    if (!request.hasOwnProperty('ExcludeGroups') || (request.ExcludeGroups == null))
                        request.ExcludeGroups = [];
                    if (!request.hasOwnProperty('IncludeKeywords') || (request.IncludeKeywords == null))
                        request.IncludeKeywords = [];
                    if (!request.hasOwnProperty('ExcludeKeywords') || (request.ExcludeKeywords == null))
                        request.ExcludeKeywords = [];
                    // Store the request in the pending slot and overwrite any pending
                    this._requestActive = null;
                    this._requestPending = request;
                    // Stop with storing request if it comes in whilst we are still setting up
                    if (this._componentReady && this._cacheReady)
                        this._servicePendingRequest();
                    return true;
                };
                this._servicePendingRequest = () => {
                    // Nothing to do if nothing pending
                    if (!this._requestPending)
                        return;
                    // Bump pending request to active status
                    this._requestActive = this._requestPending;
                    this._requestPending = null;
                };
                this._createStandaloneRecordType = () => {
                    return {
                        Id: 0,
                        Name: "Standard Keyword Types",
                        TranslatedName: "Standard Keyword Types",
                        Type: "StandAlone",
                        ReadOnly: false,
                        KeywordTypes: []
                    };
                };
                this._groupAddCallback = (group) => {
                    this._groupMap[group.Id] = group;
                };
                this._groupRemoveCallback = (group) => {
                    delete (this._groupMap[group.Id]);
                };
                this._log = core.Logging.getLogger(LOG_CATEGORY);
                this._core.OBHelper.LoadKeywordTypes(this._cacheUpdated);
                if (!ComponentKeywordsBase.Html)
                    core.Loader.getVersionedHTML('widgets/components/keywords.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                else {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            // Accessors to iterate and return
            static get CounterString() {
                ComponentKeywordsBase._staticItemCounter++;
                return ComponentKeywordsBase._staticItemCounter.toString();
            }
            static get CounterValue() {
                ComponentKeywordsBase._staticItemCounter++;
                return ComponentKeywordsBase._staticItemCounter;
            }
            get ActiveRequest() {
                return this._requestActive;
            }
            // This one is needed by two children, so include here
            get KeywordRecords() {
                let records = [];
                for (let groupId in this._groupMap) {
                    if (this._groupMap[groupId].HasKeywords)
                        records.push(this._groupMap[groupId].KeywordRecord);
                }
                return records;
            }
            get Properties() {
                let props = [];
                for (let groupId in this._groupMap) {
                    props.push(...this._groupMap[groupId].Properties);
                }
                return props;
            }
            get EditResult() {
                return {
                    DocProperties: this.Properties,
                    KeywordRecords: this.KeywordRecords
                };
            }
            get Valid() {
                let valid = true;
                for (let groupId in this._groupMap) {
                    if (!this._groupMap[groupId].Valid)
                        valid = false;
                }
                return valid;
            }
            _present() {
                
                this._formId = `keywordComponentEditForm_${ComponentKeywordsBase._staticFormCounter++}`;
                this._container.innerHTML = ComponentKeywordsBase.Html.replace('keywordComponentEditForm', this._formId);
                this._listRoot = this._container.querySelector('#keywordComponentKeywordList');
                this._form = this._container.querySelector(`#${this._formId}`);
                this._componentReady = true;
                if (this._requestPending && this._cacheReady)
                    this._servicePendingRequest();
            }
            clearDisplay() {
                this._requestActive = null;
                this._listRoot.innerHTML = '';
                this._groupMap = {};
            }
        }
        ComponentKeywordsBase.Html = null; // Probably common
        ComponentKeywordsBase._staticFormCounter = 1;
        ComponentKeywordsBase._staticItemCounter = 0;
        ComponentKeywordsBase._sortMap = { "StandAlone": 1, "SingleInstance": 2, "MultiInstance": 3 };
        Widgets.ComponentKeywordsBase = ComponentKeywordsBase;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
